import { render, staticRenderFns } from "./TopRatedDev.vue?vue&type=template&id=39273c1f&scoped=true&"
import script from "./TopRatedDev.vue?vue&type=script&lang=js&"
export * from "./TopRatedDev.vue?vue&type=script&lang=js&"
import style0 from "./TopRatedDev.vue?vue&type=style&index=0&id=39273c1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39273c1f",
  null
  
)

export default component.exports